// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"deb67b1f","370":"3cb7ae83","484":"b8dfb80e","630":"17844cfb","678":"a338ad17","796":"0a05236c"}[chunkId] + ".chunk.js";
};